import React from 'react'
import '../styles/mbprivacy.css';

const MBPrivacy = () => (
  <div class="privacy">
    <h1>Privacy Policy for Mindful Breathing</h1>
    <div>Last updated: February 05, 2022</div>

    <h1>Privacy Policy</h1>
    <div>This app is a simple breathing exercise programming guide. This app doesn't need any information directly or indirectly. App can be simply used without providing any information.</div>

    <div>Also this is a Offline application meaning none of the information stored any where in the server. And doesn't have any Ads or tracking or analytics.</div>

    <div>If you have any questions please contact us at <a href="dandapps.info@gmail.com">dandapps.info@gmail.com</a></div>
    <h1>Interpretation and Definitions</h1>

    <h2>Interpretation</h2>

    <div>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</div>

    <h2>Interpretation</h2>

    <div>For the purposes of this Privacy Policy:</div>

    <ul>
      <li>Account: means a unique account created for You to access our Service or parts of our Service.</li>
      <li>Affiliate: means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
      <li>Application: means the software program provided by the Company downloaded by You on any electronic device, named Mindful Breathing</li>
      <li>Company: (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Mindful Breathing.</li>
      <li>Country refers to: California, United States</li>
      <li>Device: means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
      <li>Personal Data: is any information that relates to an identified or identifiable individual.</li>
      <li>Service: refers to the Application.</li>
      <li>Service: Provider means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
      <li>Usage Data refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
      <li>You means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
    </ul>

    <h2>What we collect</h2>

    <div>This is a static and offline application. Doesn't collect any personal data.</div>

    <ul>
      <li>Country of origin</li>
      <li>Browser type and version number</li>
      <li>operating system</li>
      <li>User saved settings for this app</li>
    </ul>

    <div>This information is collected just to serve you better. And stored in device local storage. Not pushed to any server.</div>

    <h2>What we don’t collect</h2>

    <div>We don't collect any user personal or public data. No login or sign up required. </div>

    <div>The only user input information is related breathing programming preferences. That are stored in device local storage and not uploaded to any server. It will be cleared once the app is uninstalled.</div>

    <ul>
      <li>No personal or public data collected at all</li>
      <li>No cookis or anlytics</li>
      <li>No advertisements or popups</li>
      <li>No tracking or monitorig</li>
      <li>No login or sign up</li>
      <li>No page tracking</li>
      <li>No information shared back to us</li>
      <li>No third party site or external links</li>
      <li>No webview links</li>
      <li>No social media links</li>
      <li>No communication with people withing in the app</li>
      <li>No special APIs or SDKs</li>
      <li>No Augmented Reality</li>
      <li>No user input is mandatory</li>
      <li>No automatic collection of information for performance calculation</li>
      <li>App content is appropriate to children to help with breathing exercises</li>
    </ul>

    <h1>Your rights according to the GDPR</h1>
    <div>Since we don't collect or ask or store any information, we also don't ask for any consent.</div>
    <div>if you find or think anything is missing, please contact us at <a href="dandapps.info@gmail.com">dandapps.info@gmail.com</a></div>
    <h1>Children's Privacy</h1>

    <div>The Applications are designed for the whole family, including young children under 13 years of age under parent supervision. Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers. If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</div>

    <h1>Links to Other Websites</h1>

    <div>Our services doens't contian any third party or external links. It just connect to company website to give you more information. And provides company email to receive your feedback.</div>
    <div>App also has option to see company email, share link and website to respond with some feedback or issues. As part of the nothing is stored or not redirected to any non related links.</div>
    
    <h1>Changes to this Privacy Policy</h1>
    <div>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</div>
    <div>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.</div>
    <div>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</div>
    
    <h1>Contact Us</h1>
    <div>If you have any questions about this Privacy Policy, You can contact us:</div>
    <div>By visiting this page on our website <a href="https://dandapps.github.io/">https://dandapps.github.io/</a></div>
    <div>Email us at <a href="dandapps.info@gmail.com">dandapps.info@gmail.com</a></div>
  </div>
)

export default MBPrivacy
